import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Divider } from 'antd';

import FilterSearch from '@src/components/filter-panel/FilterSearch';
import {
  DEFAULT_FILTERS,
  RECENT_FILTERS,
  FIXED_FILTERS,
} from '@src/components/filter-panel/constants';

import { useDispatch, useSelector } from 'react-redux';
import { filtersSelector } from '@store/filterContainer/selectors';
import { applyFilter, resetBreadcrumb, pushBreadcrumb } from '@store/overviewDashboard/base/actions';
import {
  buildRecentFilterPills,
  buildDefaultFilterPills,
} from './utils';
import { StyledPopup, StyledClose, StyledRecentFilters } from './styled';

function FilterPopup({ onCancel, appliedFilter }) {
  const filters = useSelector(filtersSelector);
  const dispatch = useDispatch();

  const applySelectedFilter = (selectedFilter) => {
    dispatch(resetBreadcrumb());
    // bread crumb should not be shown if the selected filter is all traffic
    if (selectedFilter && selectedFilter.name !== 'All Traffic') {
      dispatch(pushBreadcrumb(selectedFilter));
    }
    dispatch(applyFilter(selectedFilter));
    onCancel();
  };

  const onSearchSelect = (filterKey) => {
    const selectedFilter = filters
      .concat(FIXED_FILTERS)
      .find(filter => (filter.fid || filter.name) === filterKey);
    applySelectedFilter(selectedFilter);
  };

  const onClickRecentFilter = (selectedFilter: any) => () => applySelectedFilter(selectedFilter);

  const defaultFilters = buildDefaultFilterPills(appliedFilter, onClickRecentFilter);
  const recentFilters = buildRecentFilterPills(filters, appliedFilter, onClickRecentFilter);

  return (
    <StyledPopup>
      <StyledClose>
        <CloseOutlined onClick={onCancel} />
      </StyledClose>
      <FilterSearch
        filters={filters}
        selectedFilters={[]} // do not show selected filters on search area
        onSelect={onSearchSelect}
      />
      <h3 className="dib mr-3">{DEFAULT_FILTERS}</h3>
      {defaultFilters}
      <Divider style={{ margin: '.2rem 0 .5rem 0' }} />
      <h3>{RECENT_FILTERS}</h3>
      <StyledRecentFilters>{recentFilters}</StyledRecentFilters>
    </StyledPopup>
  );
}

export default FilterPopup;
